// ./src/contexts/VenuesContext/VenuesContext.tsx
import React, { createContext, useContext } from "react";
import {
  DisplayLayoutContextValue,
  DisplayLayoutProviderProps,
} from "./DisplayLayoutContext.types";
import { useDisplayLayouts } from "@/hooks";

const DisplayLayoutContext = createContext<
  DisplayLayoutContextValue | undefined
>(undefined);

export const DisplayLayoutProvider: React.FC<DisplayLayoutProviderProps> = ({
  children,
  options = {},
}) => {
  const displayLayoutHook = useDisplayLayouts(options);

  return (
    <DisplayLayoutContext.Provider value={displayLayoutHook}>
      {children}
    </DisplayLayoutContext.Provider>
  );
};

// Custom hook for using the venues context
export const useDisplayLayoutContext = (): DisplayLayoutContextValue => {
  const context = useContext(DisplayLayoutContext);

  if (context === undefined) {
    throw new Error(
      "useDisplayLayoutContext must be used within a DisplayLayoutProvider"
    );
  }
  return context;
};
